import React from 'react';
import '../../styles/RailTile.css';
import PropTypes from 'prop-types';

const FullCancelled = ({ trainName, trainNo, trainSrc, trainDstn, startDate, trainType }) => {
  return (
    <div className="railTile">
      <div className="trainNameNoWrap">
        <span className="blackText latoBlack trainName">{trainName}</span>
        <span className="lightGreyText trainNo">{trainNo}</span>
      </div>
      <div className="trainOtherInfo">
        <div className="stationDateInfo">
          <span className="blackText">{trainSrc}</span>
          <span className="longArrowIcon railSeoSprite appendRight10 appendLeft10"></span>
          <span className="blackText">{trainDstn}</span>
          <span className="appendRight10 appendLeft10 lightGreyText">|</span>
          <span className="blackText">{startDate}</span>
          <span className="appendRight10 appendLeft10 lightGreyText">|</span>
          <span className="blackText">{trainType}</span>
        </div>
      </div>
    </div>
  );
};

FullCancelled.propTypes = {
  trainName: PropTypes.string,
  trainNo: PropTypes.string,
  trainSrc: PropTypes.string,
  trainDstn: PropTypes.string,
  startDate: PropTypes.string,
  trainType: PropTypes.string
};

export default FullCancelled;
